import { Button, MessageBoxType } from '@ui5/webcomponents-react';
import { useStyles } from './DistributeQuery.jss';
import { useTranslation } from 'react-i18next';
import '@ui5/webcomponents-icons/dist/complete';
import { ConfirmationDialog } from 'components/shared/ConfirmationDialog';
import { useState } from 'react';
import { ResultUserMessage } from 'components/shared/UserMessage';
import { useDistributeQueryMutation } from 'generated/graphql';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';

export interface DistributeQueryProps {
  id: string;
  setResultMessage: (value: ResultUserMessage) => void;
  setIsUserMessageOpen: (value: boolean) => void;
}

export const DistributeQuery: React.FC<DistributeQueryProps> = (props) => {
  const { id, setResultMessage, setIsUserMessageOpen } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const [, distributeQueryMutation] = useDistributeQueryMutation();

  const distributeQuery = async () => {
    const { data, error } = await distributeQueryMutation({ id });

    if (data?.query && !error) {
      setResultMessage({
        isSuccess: true,
        message: t('display-query-actions-distribute-success')
      });
    } else {
      setResultMessage({
        isSuccess: false,
        message: t('display-query-actions-distribute-error')
      });
    }
    setIsUserMessageOpen(true);
  };

  return (
    <>
      <Button
        className={classes.actionGroupItem}
        data-testid="display-query-distribute-query"
        data-help-id="display-query-distribute-query"
        id="distribute-query-button"
        onClick={() => setIsConfirmDialogOpen(true)}
        design={ButtonDesign.Default}
      >
        {t('display-query-distribute-query')}
      </Button>
      <ConfirmationDialog
        data-testid="display-query-actions-confirm-dialog-distribute"
        open={isConfirmDialogOpen}
        type={MessageBoxType.Confirm}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={distributeQuery}
      >
        {t('display-query-actions-confirm-dialog-distribute')}
      </ConfirmationDialog>
    </>
  );
};
